<template>
  <ul
    class="enhancements-list"
    data-component="enhancements-list"
  >
    <enhancement-card
      v-for="enhancement in enhancementsList"
      :key="enhancement.name"
      :enhancement="enhancement"
      @select-enhancement="selectEnhancement"
      @remove-enhancement="$emit('remove-enhancement', $event)"
      @edit-enhancement="$emit('edit-enhancement', $event)"
      :number-of-selected-enhancements="selectedEnhancements"
      :ignore-max-number="ignoreMaxNumber"
    />
  </ul>
</template>

<script>
  import EnhancementCard from './enhancement-card.vue'

  export default {
  name: 'enhancements-list',
    components: {
      EnhancementCard
    },
    props: {
      enhancementsList: {
        type: Array,
        required: true
      },
      selectedEnhancements: {
        type: Number,
        required: false,
      },
      ignoreMaxNumber: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      selectEnhancement(enhancement) {
        this.$emit('select-enhancement', enhancement)
      }
    }
  }
</script>
